import { render } from "./CommonFilesTable.vue?vue&type=template&id=1b9b29c9"
import script from "./CommonFilesTable.vue?vue&type=script&lang=js"
export * from "./CommonFilesTable.vue?vue&type=script&lang=js"

import "./CommonFilesTable.vue?vue&type=style&index=0&id=1b9b29c9&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__